// extracted by mini-css-extract-plugin
export var clauseRow = "_ba-6";
export var emptyState = "_ba-d";
export var filterContent = "_ba-a";
export var filterGroup = "_ba-1";
export var filterGroupContainer = "_ba-0";
export var nestedGroup = "_ba-2";
export var nestedGroupContent = "_ba-b";
export var nestedGroupDepth1 = "_ba-3";
export var nestedGroupDepth2 = "_ba-4";
export var nestedGroupDepth3 = "_ba-5";
export var nestedGroupEmpty = "_ba-c";
export var operatorAnd = "_ba-8";
export var operatorOr = "_ba-9";
export var operatorToggle = "_ba-7";
export var removeGroupButton = "_ba-e";